import Vue from "vue";

export default {
  saveLinkDefaultViewType: (state, linkDefaultViewType) => {
    Vue.set(state, "linkDefaultViewType", linkDefaultViewType);
  }
};
